import Image from 'next/image'

import { STATIC_URL } from 'constants/data'

const ImageBeamedDefault = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/beamed_default.png`}
    alt="Превью"
    width={122}
    height={122}
    unoptimized
  />
)

const IconPlay = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/icon_play.svg`}
    alt="Воспроизведение"
    width={40}
    height={40}
  />
)

const IconPause = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/icon_pause.svg`}
    alt="Пауза"
    width={40}
    height={40}
  />
)

const IconForward = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/icon_forward15.svg`}
    alt="Вперед"
    width={24}
    height={24}
  />
)

const IconBackward = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/icon_backward15.svg`}
    alt="Назад"
    width={24}
    height={24}
  />
)

const IconVolumeMax = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/icon_volume.svg`}
    alt="Громкость"
    width={24}
    height={24}
  />
)

const IconVolumeMin = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/icon_volume_low.svg`}
    alt="Громкость"
    width={24}
    height={24}
    style={{ marginLeft: '-2px' }}
  />
)

const IconVolumeMuted = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/icon_volume_muted.svg`}
    alt="Громкость"
    width={24}
    height={24}
  />
)

const IconSpeed2x = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/icon_speed_2x.svg`}
    alt="Скорость"
    width={24}
    height={24}
  />
)

const IconSpeed1x = () => (
  <Image
    src={`${STATIC_URL}/icons/audio-controls/icon_speed_1x.svg`}
    alt="Скорость"
    width={24}
    height={24}
  />
)

export {
  ImageBeamedDefault,
  IconPlay,
  IconPause,
  IconForward,
  IconBackward,
  IconVolumeMax,
  IconVolumeMin,
  IconVolumeMuted,
  IconSpeed2x,
  IconSpeed1x,
}
